import React from 'react';
import { FaHome, FaPhone, FaMailBulk, FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
          <div className="location">
            <FaHome size={20} className="contact-icon"/>
            <div>
              <p>Minneapolis, MN</p>
              <p>United States</p>
            </div>
          </div>
          <div className="phone">
            <FaPhone size={20} className="contact-icon"/>
            <div>
              <p>(507) 339-4520</p>
            </div>
          </div>
          <div className="email">
            <FaMailBulk size={20} className="contact-icon"/>
            <div>
              <p>canopy.systems1@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="right">
          <h4>About Canopy Systems</h4>
          <p>Canopy Systems is an initiative to leverage technology to grow and maintain plants in a controlled environment sustainably and long-term. We currently focus on growing and offering a wide variety of unique and rare Carnivorous Plants varieties to other excited growers in the U.S.</p>
          <div className="social">
            <a href="https://www.instagram.com/canopy_systems_/">
              <FaInstagram size={24} style={{ color: "#E1306C", marginRight: "1rem" }}/>
            </a>
            <a href="https://www.facebook.com/realalurellc/">
              <FaFacebook size={24} style={{ color: "#4267B2", marginRight: "1rem" }}/>
            </a>
            <a href="https://www.youtube.com/@CanopySystemsTech">
              <FaYoutube size={24} style={{ color: "#FF0000", marginRight: "1rem" }}/>
            </a>
            <a href="https://www.linkedin.com/company/canopy-systems/?viewAsMember=true">
              <FaLinkedin size={24} style={{ color: "#0077B5", marginRight: "1rem" }}/>
            </a>
          </div>
          <p className="footer-copyright">Copyright {new Date().getFullYear()} Canopy Systems. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
